import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.store';
import { isLyrraOne } from '@/lib/platform';
import { canAccessTrainerDashboard } from '@/lib/auth-role';
import { isLyrraOneSetupWizardCompleted } from '@/lib/lyrraone-setup-wizard';
import type { UserRole } from '@/types';

export function useLyrraOneSetupWizard() {
  const user = useAuthStore((s) => s.user);
  const [searchParams] = useSearchParams();
  const forceOpen = searchParams.get('setup') === '1';

  const completed = useMemo(
    () => isLyrraOneSetupWizardCompleted(user?.preferences),
    [user?.preferences],
  );

  const eligible = Boolean(
    isLyrraOne()
      && user
      && canAccessTrainerDashboard((user.role ?? 'teacher') as UserRole),
  );

  const shouldShow = eligible && (!completed || forceOpen);

  return {
    shouldShow,
    eligible,
    completed,
    forceOpen,
    user,
  };
}
